jQuery(document).ready(function() {
	console.log("test header");

	jQuery('.site-nav__invisible.site-nav__item--has-dropdown a').attr("tabindex","-1");
	jQuery('.site-nav__invisible.site-nav__item--has-dropdown a').attr("aria-hidden","true");

	jQuery('.subscribe-form__heading, .footer-block__heading').attr("role","heading");
	jQuery('.subscribe-form__heading, .footer-block__heading').attr("aria-level","2");
	jQuery('.subscribe-form__email.required').attr("autocomplete","email");
	jQuery('.slick-dots').removeAttr("aria-hidden");

	jQuery('.btn--plain.prev.icon.feather-icon.slick-arrow').attr("aria-label","Previous Slide");
	jQuery('.btn--plain.next.icon.feather-icon.slick-arrow').attr("aria-label","Next Slide");

  jQuery('.btn--plain prev.icon.feather-icon.slick-arrow.slick-disabled').attr("aria-label","Previous Slide");
	jQuery('.btn--plain next.icon.feather-icon.slick-arrow').attr("aria-label","Next Slide");
  
	jQuery('.product-block__image.image-one').attr("aria-hidden","true");
	jQuery('.product-block__image.image-one').attr("tabindex","-1");
  jQuery('.product-block__image.product-block__image--shape-natural').attr("aria-hidden","true");
	jQuery('.product-block__image.product-block__image--shape-natural').attr("tabindex","-1");
  


  
	jQuery('input[name="customer[email]"]').attr('autocomplete', 'email');
	jQuery('input[name="customer[password]"]').attr('autocomplete', 'current-password');

	jQuery('input[name="customer[first_name]"]').attr('autocomplete', 'given-name');
	jQuery('input[name="customer[last_name]"]').attr('autocomplete', 'family-name');

	jQuery('.recently-viewed h4, .cc-filters-results__summary').attr("aria-level","2");

	jQuery('.flex-1.font-sans.text-body-large').attr("aria-level","3");
	jQuery('.flex-1.font-sans.text-body-large, .cc-filters-results__summary').attr("role","heading");


	jQuery('.cbb-frequently-bought-selector-input').removeAttr("aria-label");

 

	jQuery('.product-detail__image.slick-slide.slick-current.slick-active').attr("aria-label","heading");


	jQuery('.product-detail__thumbnails').attr("role","list");
	jQuery('.product-detail__thumbnails a').attr("role","listitem");
  jQuery('.breadcrumbs-prod-nav svg title').remove();

  //jQuery('.product-block__image.image-one').removeAttr("href");

  
  

	jQuery('a:contains("Ask a question!")').attr('aria-label', 'Ask a question!');
  jQuery('a .icon-yelp').parent('a').attr('aria-label', "Visit Benny's Tacos on Yelp (opens in new tab)");




   setTimeout(function(){ 
        
    jQuery('.cbb-frequently-bought-selector-label-compare-at-price').prepend('<span class="sr-only">Old price </span>');
    jQuery('.cbb-frequently-bought-total-price-was-price').prepend('<span class="sr-only">Old price </span>');
    jQuery('.product-price__compare.theme-money').prepend('<span class="sr-only">Old price </span>');

    
     },
  5000); 


   });





   // custome code block start from here 

   jQuery(function ($) {

  setTimeout(function () {

    $('.collection-filters-container.cf-select-wrapper').each(function (index) {

      var $wrapper = $(this);
      var $select  = $wrapper.find('.cf-select');
      var $span    = $wrapper.find('.cf-label.cf-title');

      // create unique id
      var selectId = 'cf-select-' + index;

      // add id to select
      $select.attr('id', selectId);

      // replace span with label
      var $label = $('<label>', {
        'class': $span.attr('class'),
        'for': selectId,
        'text': $span.text()
      });

      $span.replaceWith($label);

    });

  }, 4000); // 4 seconds delay

});



   // custome code block start from here 



   
 

jQuery(function ($) {

  // check after page loads
  var $errors = $('.errors');

  if ($errors.length) {

    // add alert role dynamically
    $errors.attr({
      
    'role': 'alert',
      'aria-live': 'assertive',
      'tabindex': '-1'

    });

    // move focus so screen reader announces
    setTimeout(function () {
      $errors.focus();
    }, 100);
  }

});

   // custome code block start from here 



   jQuery(function ($) {

  function updateSlideDotText() {

    $('.slick-dots li button').each(function (index) {

      var slideNumber = index + 1;

      // change visible text
      $(this).text(slideNumber + ' slide');

      // improve accessibility
      $(this).attr('aria-label', 'Go to slide ' + slideNumber);

    });
  }

  // Run once after page load (delay needed for Shopify)
  setTimeout(updateSlideDotText, 800);

  // Run again whenever slick changes or refreshes
  $(document).on('afterChange init reInit', '.slick-slider', function () {
    updateSlideDotText();
  });

});


   // custome code block start from here 







jQuery(function ($) {

  var target = document.querySelector(
    '#shopify-section-template--18604908937283__slideshow .slick-dots'
  );

  if (!target) return;

  const observer = new MutationObserver(function () {

    if (target.getAttribute('aria-hidden') === 'true') {
      target.removeAttribute('aria-hidden');
    }

  });

  observer.observe(target, {
    attributes: true,
    attributeFilter: ['aria-hidden']
  });

});

   // custome code block start from here 



   // Play/Pause button

 
// document.addEventListener('DOMContentLoaded', function () {
//   const slider = document.querySelector('.js-slideshow-section');
//   const toggleBtn = document.getElementById('slideshow-toggle');

//   if (!slider || !toggleBtn || !window.jQuery) return;

//   const $slider = jQuery(slider);
//   let isPlaying = true;

//   function updateButton() {
//     if (isPlaying) {
//       toggleBtn.setAttribute('aria-pressed', 'true');
//       toggleBtn.setAttribute('aria-label', 'Pause slideshow');
//       toggleBtn.innerHTML = '❚❚';
//     } else {
//       toggleBtn.setAttribute('aria-pressed', 'false');
//       toggleBtn.setAttribute('aria-label', 'Play slideshow');
//       toggleBtn.innerHTML = '▶';
//     }

//     // 🔑 Keep focus stable
//     toggleBtn.focus();
//   }

//   toggleBtn.addEventListener('click', function () {
//     if (isPlaying) {
//       $slider.slick('slickPause');
//     } else {
//       $slider.slick('slickPlay');
//     }

//     isPlaying = !isPlaying;
//     updateButton();
//   });

//   // Space / Enter support
//   toggleBtn.addEventListener('keydown', function (e) {
//     if (e.key === ' ' || e.key === 'Enter') {
//       e.preventDefault();
//       toggleBtn.click();
//     }
//   });
// });
 
   // custome code block ends here 



   // search focus trap

 const openBtn = document.querySelector('.js-search-form-open');
const closeBtn = document.querySelector('.js-search-form-close');
const modal = document.querySelector('.search-bar');

let lastFocusedElement = null;

const focusableSelectors = `
  button:not([disabled]),
  [href],
  input:not([disabled]),
  select:not([disabled]),
  textarea:not([disabled]),
  [tabindex]:not([tabindex="-1"])
`;

// OPEN
openBtn.addEventListener('click', () => {

  lastFocusedElement = document.activeElement;

  modal.removeAttribute('hidden');
  modal.setAttribute('aria-modal', 'true');

  // Wait one frame (important if Shopify animates)
  requestAnimationFrame(() => {
    const focusableElements = getFocusableElements();
    if (focusableElements.length) {
      focusableElements[0].focus();
    }
  });

  modal.addEventListener('keydown', trapFocus);
});

// CLOSE
closeBtn.addEventListener('click', closeModal);

function closeModal() {

  modal.setAttribute('hidden', true);
  modal.removeAttribute('aria-modal');

  modal.removeEventListener('keydown', trapFocus);

  if (lastFocusedElement) {
    lastFocusedElement.focus();
  }
}

// GET ONLY VISIBLE FOCUSABLE ELEMENTS
function getFocusableElements() {
  return Array.from(modal.querySelectorAll(focusableSelectors))
    .filter(el => el.offsetParent !== null); // filters hidden elements
}

// FOCUS TRAP
function trapFocus(e) {

  if (e.key === 'Escape') {
    e.preventDefault();
    closeModal();
    return;
  }

  if (e.key !== 'Tab') return;

  const focusableElements = getFocusableElements();
  if (!focusableElements.length) return;

  const firstElement = focusableElements[0];
  const lastElement = focusableElements[focusableElements.length - 1];

  if (e.shiftKey) {
    if (document.activeElement === firstElement) {
      e.preventDefault();
      lastElement.focus();
    }
  } else {
    if (document.activeElement === lastElement) {
      e.preventDefault();
      firstElement.focus();
    }
  }
}


// Replace h3 with label bug id 48

$('.cbb-frequently-bought-selector-label-name').each(function () {
  $(this).replaceWith(function () {
    return $('<label>', {
      class: this.className,
      style: this.style.cssText,
      html: $(this).html()
    });
  });
});


$('.cbb-frequently-bought-selector-list li').each(function () {
  const $li = $(this);
  const $checkbox = $li.find('.cbb-frequently-bought-selector-input');
  const checkboxId = $checkbox.attr('id');

  if (!checkboxId) return;

  const $label = $li.find('.cbb-frequently-bought-selector-label-name').first();

  if ($label.length) {
    $label.attr('for', checkboxId);
  }

  // Remove invalid "for" attributes on non-label elements
  $li.find('span[for]').removeAttr('for');
});


$('.cbb-frequently-bought-selector-list li').each(function () {
  const $li = $(this);

  // Get product name from visible label
  const productName = $li
    .find('.cbb-frequently-bought-selector-label-name')
    .text()
    .replace(/\s+/g, ' ')
    .trim();

  // Find variant select
  const $select = $li.find('.cbb-recommendations-variant-select');

  if (!$select.length || !productName) return;

  // Get selected option text
  const selectedVariant = $select.find('option:selected').text().trim();

  // Set aria-label
  $select.attr(
    'aria-label',
    productName + ' variant select ' + selectedVariant
  );
});



$('.cbb-recommendations-variant-select').on('change', function () {
  const $select = $(this);
  const $li = $select.closest('li');

  const productName = $li
    .find('.cbb-frequently-bought-selector-label-name')
    .text()
    .replace(/\s+/g, ' ')
    .trim();

  const selectedVariant = $select.find('option:selected').text().trim();

  $select.attr(
    'aria-label',
    productName + ' variant select ' + selectedVariant
  );
});



//===================================== Quantity bug ID 40 Startes. =========================================


// $(document).ready(function () {
//   const $btn = $('#qty-proxy .cc-select__btn');

//   // Wrap the visible value in a span (only once)
//   if (!$btn.find('#qty-proxy-value').length) {
//     const textNode = $btn.contents().filter(function () {
//       return this.nodeType === 3 && $.trim(this.nodeValue) !== '';
//     }).first();

//     if (textNode.length) {
//       $('<span id="qty-proxy-value"></span>')
//         .text($.trim(textNode.text()))
//         .insertBefore(textNode);
//       textNode.remove();
//     }
//   }
// });


// $('#qty-proxy .cc-select__btn').attr({
//   'id': 'qty-proxy-button',
//   'aria-haspopup': 'listbox',
//   'aria-expanded': 'false',
//   'aria-labelledby': 'qty-proxy-label qty-proxy-value'
// });


// $('.cc-select__option').on('click keydown', function (e) {
//   if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {

//     e.preventDefault();

//     const value = $(this).text().trim();

//     // Update visible value
//     $('#qty-proxy-value').text(value);

//     // Update selected state
//     $('.cc-select__option').attr('aria-selected', 'false');
//     $(this).attr('aria-selected', 'true');

//     // Update aria-activedescendant
//     $('.cc-select__listbox')
//       .attr('aria-activedescendant', $(this).attr('id'));

//     // Collapse combobox
//     $('#qty-proxy-button')
//       .attr('aria-expanded', 'false');

//     $('.cc-select__listbox')
//       .attr('aria-hidden', 'true');
//   }
// });

// $('#qty-proxy .cc-select__btn').on('click', function () {
//   const expanded = $(this).attr('aria-expanded') === 'true';

//   $(this).attr('aria-expanded', String(!expanded));
//   $('.cc-select__listbox').attr('aria-hidden', expanded);
// });


//===================================== Quantity bug ID 40 End. =========================================

//===================================== QuickView carousel aria-live bug ID 24 Start. =========================================


function initQuickbuyCarouselA11y() {
  var $mediaContainer = $('.quickbuy__media-container');

  if (!$mediaContainer.length) return;

  // Prevent duplicate initialization
  if ($mediaContainer.data('a11y-initialized')) return;
  $mediaContainer.data('a11y-initialized', true);

  /* ----------------------------------
     1. Inject live region (once)
  ---------------------------------- */
  if (!$('#quickbuy-carousel-live').length) {
    $('<div>', {
      id: 'quickbuy-carousel-live',
      'aria-live': 'assertive',
      'aria-atomic': 'true',
      class: 'sr-only'
    }).appendTo($mediaContainer);
  }

  /* ----------------------------------
     2. Slick carousel announcement
  ---------------------------------- */
  $('.quickbuy__product-media').on('afterChange', function (event, slick, currentSlide) {
    $('#quickbuy-carousel-live').text(
      'Product image ' + (currentSlide + 1) + ' of ' + slick.slideCount
    );
  });

  /* ----------------------------------
     3. Fallback: MutationObserver
  ---------------------------------- */
  $('.quickbuy__product-media').each(function () {
    var $container = $(this);
    var total = $container.find('.quickbuy__product-media-item').length;

    var observer = new MutationObserver(function () {
      var index =
        $container
          .find('.quickbuy__product-media-item:not([aria-hidden="true"])')
          .index() + 1;

      if (index > 0) {
        $('#quickbuy-carousel-live').text(
          'Product image ' + index + ' of ' + total
        );
      }
    });

    observer.observe(this, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class', 'aria-hidden']
    });
  });

  /* ----------------------------------
     4. Initial announcement
  ---------------------------------- */
  var total = $('.quickbuy__product-media-item').length;
  if (total) {
    $('#quickbuy-carousel-live').text(
      'Product image 1 of ' + total
    );
  }
}


var quickbuyObserver = new MutationObserver(function () {
  if ($('.quickbuy__media-container').length) {
    initQuickbuyCarouselA11y();
  }
});

quickbuyObserver.observe(document.body, {
  childList: true,
  subtree: true
});


//===================================== QuickView carousel aria-live bug ID 24 End. =========================================


//===================================== QuickView carousel aria-live bug ID 22 Starts. =========================================



jQuery(document).ready(function ($) {

  if ($('#sr-slide-announcer').length === 0) {
    $('body').append(
      '<div id="sr-slide-announcer" ' +
      'aria-live="assertive" aria-atomic="true" ' +
      'style="position:absolute; left:-9999px; width:1px; height:1px; overflow:hidden;">' +
      '</div>'
    );
  }

});


jQuery(document).ready(function ($) {

  function announceSlide(slideIndex) {
    var slideNumber = slideIndex + 1;
    $('#sr-slide-announcer').text(
      'Slide ' + slideNumber + ' appears'
    );
  }

  var $slideshow = $('.js-slideshow-section');

  /* NEXT arrow */
  $(document).on('click keydown',
    '.btn--plain.next.slick-arrow',
    function (e) {
      if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
        var slick = $slideshow.slick('getSlick');
        announceSlide(slick.currentSlide + 1);
      }
    }
  );

  /* PREVIOUS arrow */
  $(document).on('click keydown',
    '.btn--plain.prev.slick-arrow',
    function (e) {
      if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
        var slick = $slideshow.slick('getSlick');
        announceSlide(slick.currentSlide - 1);
      }
    }
  );

  /* PAGINATION DOTS */
  $(document).on('click keydown',
    '.slick-dots button',
    function (e) {
      if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
        var slideIndex = $(this).parent().index();
        $('#sr-slide-announcer').text(
          'New slide ' + (slideIndex + 1) + ' appears'
        );
      }
    }
  );

});


//=====================================  Quantity aria-live bug ID 40 Starts. =========================================


// jQuery(document).ready(function ($) {

//   var $existingInput = $('#Quantity');
//   var currentValue = $existingInput.val() || '1';

//   var quantityHTML = `
//     <div class="qty-wrapper">
//       <label for="quantity-select" class="label no-js-hidden">Quantity</label>
//             <div class="custom-dropdown">
//         <button class="dropdown-btn">1</button>

//         <ul class="dropdown-list">
//           <li data-value="1">1</li>
//           <li data-value="2">2</li>
//           <li data-value="3">3</li>
//           <li data-value="4">4</li>
//           <li data-value="5">5</li>
//           <li data-value="6">6</li>
//           <li data-value="7">7</li>
//           <li data-value="8">8</li>
//           <li data-value="9">9</li>
//           <li data-value="10+">10+</li>
//         </ul>
// </div>
//       <input type="hidden" id="quantityInput" value="1">
//     </div>
//   `;

//   // Must be inside ready(), where quantityHTML is defined
//   $('.qty-wrapper').replaceWith(quantityHTML);

//   // Restore selected value if possible
//   $('#quantity-select').val(currentValue);

//   $(document).on('keydown', '#quantity-select', function (e) {
//     if (e.key === 'Enter') {
//       e.preventDefault();
//       e.stopPropagation();
//       this.click();
//     }
//   });

// });

// jQuery(document).ready(function ($) {

//   var $existingInput = $('#Quantity');
//   var currentValue = $existingInput.val() || '1';

//   var quantityHTML = `
//     <div class="qty-wrapper">
//       <label for="quantity-select" class="label no-js-hidden">Quantity</label>
//       <select id="quantity-select" name="quantity" class="cc-select__btn" style="width: 346px;" size="5">
//         <option value="1">1</option>
//         <option value="2">2</option>
//         <option value="3">3</option>
//         <option value="4">4</option>
//         <option value="5">5</option>
//         <option value="6">6</option>
//         <option value="7">7</option>
//         <option value="8">8</option>
//         <option value="9">9</option>
//         <option value="10+">10+</option>
//       </select>
//       <input type="hidden" id="quantityInput" value="1">
//     </div>
//   `;

//   // Must be inside ready(), where quantityHTML is defined
//   $('.qty-wrapper').replaceWith(quantityHTML);

//   // Restore selected value if possible
//   $('#quantity-select').val(currentValue);

//   $(document).on('keydown', '#quantity-select', function (e) {
//     if (e.key === 'Enter') {
//       e.preventDefault();
//       e.stopPropagation();
//       this.click();
//     }
//   });

// });


// jQuery(document).ready(function ($) {

//   var $select  = $('#qty-proxy');
//   var $btn     = $select.find('.cc-select__btn');
//   var $listbox = $select.find('.cc-select__listbox');
//   var $options = $select.find('.cc-select__option');
//   var total    = $options.length;

//   // Fix ARIA on listbox
//   $listbox.attr({
//     'role'                : 'listbox',
//     'aria-label'          : 'Quantity',
//     'aria-multiselectable': 'false',
//     'id'                  : 'qty-proxy-listbox'
//   });

//   // Fix ARIA on button
//   $btn.attr({
//     'role'         : 'combobox',
//     'aria-label'   : 'Quantity, ' + ($('#qty-proxy-value').text().trim() || '1') + ' selected',
//     'aria-controls': 'qty-proxy-listbox'
//   });

//   // Fix ARIA on each option
//   $options.each(function (i) {
//     $(this).attr({
//       'role'         : 'option',
//       'aria-setsize' : total,
//       'aria-posinset': i + 1,
//       'aria-label'   : 'Quantity ' + $(this).data('value'),
//       'tabindex'     : '-1'
//     });
//   });

//   // ─── Helpers ───────────────────────────────────────────────

//   function openDropdown() {
//     var $selected = $options.filter('[aria-selected="true"]');
//     if (!$selected.length) $selected = $options.first();
//     $listbox.removeAttr('hidden');
//     $listbox.attr('aria-hidden', 'false');
//     $listbox.attr('tabindex', '0');
//     $btn.attr('aria-expanded', 'true');
//     highlightOption($selected);
//     $listbox.focus();
//   }

//   function closeDropdown() {
//     $listbox.attr('hidden', '');
//     $listbox.attr('aria-hidden', 'true');
//     $listbox.attr('tabindex', '-1');
//     $btn.attr('aria-expanded', 'false');
//     $btn.focus();
//   }

//   function highlightOption($option) {
//     $options.removeClass('cc-select__option--focused');
//     $option.addClass('cc-select__option--focused');
//     $listbox.attr('aria-activedescendant', $option.attr('id'));
//     // Scroll into view
//     var optionTop    = $option[0].offsetTop;
//     var optionBottom = optionTop + $option[0].offsetHeight;
//     var scrollTop    = $listbox[0].scrollTop;
//     var listHeight   = $listbox[0].clientHeight;
//     if (optionTop < scrollTop) {
//       $listbox[0].scrollTop = optionTop;
//     } else if (optionBottom > scrollTop + listHeight) {
//       $listbox[0].scrollTop = optionBottom - listHeight;
//     }
//   }

//   function selectOption($option) {
//     var value = $option.data('value').toString();
//     // Update aria-selected
//     $options.attr('aria-selected', 'false');
//     $option.attr('aria-selected', 'true');
//     // Update visible text via span
//     $('#qty-proxy-value').text(value);
//     // Update button aria-label for NVDA
//     $btn.attr('aria-label', 'Quantity, ' + value + ' selected');
//     // Update activedescendant
//     $listbox.attr('aria-activedescendant', $option.attr('id'));
//     // Sync to Shopify native input
//     $('#Quantity').val(value).trigger('change');
//   }

//   function getFocusedOption() {
//     var id = $listbox.attr('aria-activedescendant');
//     return id ? $('#' + id) : $options.filter('[aria-selected="true"]');
//   }

//   // ─── Events ────────────────────────────────────────────────

//   // Button click
//   $(document).on('click', '#qty-proxy .cc-select__btn', function (e) {
//     e.stopPropagation();
//     $btn.attr('aria-expanded') === 'true' ? closeDropdown() : openDropdown();
//   });

//   // Option click — closest() handles clicks on inner <span> too
//   $(document).on('click', '#qty-proxy .cc-select__option, #qty-proxy .cc-select__option span', function (e) {
//     var $option = $(e.target).closest('.cc-select__option');
//     selectOption($option);
//     closeDropdown();
//   });

//   // Click outside
//   $(document).on('click', function (e) {
//     if (!$(e.target).closest('#qty-proxy').length) {
//       if ($btn.attr('aria-expanded') === 'true') closeDropdown();
//     }
//   });

//   // Button keydown
//   $(document).on('keydown', '#qty-proxy .cc-select__btn', function (e) {
//     if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
//       e.preventDefault();
//       openDropdown();
//     }
//     if (e.key === 'Escape') closeDropdown();
//   });

//   // Listbox keydown
//   $(document).on('keydown', '#qty-proxy .cc-select__listbox', function (e) {
//     var $current = getFocusedOption();
//     var index    = $options.index($current);

//     if (e.key === 'ArrowDown') {
//       e.preventDefault();
//       var $next = $options.eq(index + 1);
//       if ($next.length) highlightOption($next);
//     }

//     if (e.key === 'ArrowUp') {
//       e.preventDefault();
//       if (index <= 0) {
//         closeDropdown();
//       } else {
//         highlightOption($options.eq(index - 1));
//       }
//     }

//     if (e.key === 'Enter' || e.key === ' ') {
//       e.preventDefault();
//       selectOption($current);
//       closeDropdown();
//     }

//     if (e.key === 'Escape') {
//       e.preventDefault();
//       closeDropdown();
//     }

//     if (e.key === 'Tab') closeDropdown();
//   });

// });  


// jQuery(document).ready(function ($) {

//   var $select  = $('#qty-proxy');
//   var $btn     = $select.find('.cc-select__btn');
//   var $listbox = $select.find('.cc-select__listbox');
//   var $options = $select.find('.cc-select__option');
//   var total    = $options.length;

//   // ─── Fix ARIA ──────────────────────────────────────────────────
//   $listbox.attr({
//     'role'                : 'listbox',
//     'aria-label'          : 'Quantity',
//     'aria-multiselectable': 'false',
//     'id'                  : 'qty-proxy-listbox'
//   });

//   var initialValue = $btn.contents().filter(function () {
//     return this.nodeType === 3 && this.nodeValue.trim() !== '';
//   }).text().trim();

//   $btn.attr({
//     'role'         : 'combobox',
//     'aria-label'   : 'Quantity, ' + initialValue + ' selected',
//     'aria-controls': 'qty-proxy-listbox'
//   });

//   $options.each(function (i) {
//     $(this).attr({
//       'role'         : 'option',
//       'aria-setsize' : total,
//       'aria-posinset': i + 1,
//       'aria-label'   : 'Quantity ' + $(this).data('value'),
//       'tabindex'     : '-1'
//     });
//   });

//   // ─── CSS ───────────────────────────────────────────────────────
//   $('<style>').text(`
//     .cc-select__option--focused {
//       background-color: #1a6fdb !important;
//       color: #fff !important;
//       outline: none;
//     }
//   `).appendTo('head');

//   // ─── Helpers ───────────────────────────────────────────────────

//   function openDropdown() {
//     var $selected = $options.filter('[aria-selected="true"]');
//     if (!$selected.length) $selected = $options.first();
//     $listbox.removeAttr('hidden');
//     $listbox.attr('aria-hidden', 'false');
//     $listbox.attr('tabindex', '0');
//     $btn.attr('aria-expanded', 'true');
//     highlightOption($selected);
//     $listbox.focus();
//   }

//   function closeDropdown() {
//     $listbox.attr('hidden', '');
//     $listbox.attr('aria-hidden', 'true');
//     $listbox.attr('tabindex', '-1');
//     $btn.attr('aria-expanded', 'false');
//     $btn.focus();
//   }

//   function highlightOption($option) {
//     if (!$option || !$option.length) return;
//     $options.removeClass('cc-select__option--focused');
//     $option.addClass('cc-select__option--focused');
//     $listbox.attr('aria-activedescendant', $option.attr('id'));
//     // Scroll into view
//     var optionTop    = $option[0].offsetTop;
//     var optionBottom = optionTop + $option[0].offsetHeight;
//     var scrollTop    = $listbox[0].scrollTop;
//     var listHeight   = $listbox[0].clientHeight;
//     if (optionTop < scrollTop) {
//       $listbox[0].scrollTop = optionTop;
//     } else if (optionBottom > scrollTop + listHeight) {
//       $listbox[0].scrollTop = optionBottom - listHeight;
//     }
//   }

//   function selectOption($option) {
//     if (!$option || !$option.length) return;
//     var value = $option.data('value').toString();

//     // Update aria states
//     $options.attr('aria-selected', 'false');
//     $option.attr('aria-selected', 'true');

//     // Update button text node directly — find and replace only the text node
//     $btn.contents().filter(function () {
//       return this.nodeType === 3 && this.nodeValue.trim() !== '';
//     }).first()[0].nodeValue = value;

//     // Update button aria-label for NVDA
//     $btn.attr('aria-label', 'Quantity, ' + value + ' selected');

//     // Update activedescendant
//     $listbox.attr('aria-activedescendant', $option.attr('id'));

//     // Sync to Shopify native input
//     $('#Quantity').val(value).trigger('change');
//   }

//   function getFocusedOption() {
//     var id = $listbox.attr('aria-activedescendant');
//     return id ? $('#' + id) : $options.filter('[aria-selected="true"]');
//   }

//   // ─── Events ────────────────────────────────────────────────────

//   // Button click
//   $(document).on('click', '#qty-proxy .cc-select__btn', function (e) {
//     e.stopPropagation();
//     $btn.attr('aria-expanded') === 'true' ? closeDropdown() : openDropdown();
//   });

//   // Option click — handle clicks on <li> and inner <span>
//   $(document).on('click', '#qty-proxy .cc-select__option, #qty-proxy .cc-select__option span', function (e) {
//     e.stopPropagation();
//     var $option = $(e.target).closest('.cc-select__option');
//     selectOption($option);
//     closeDropdown();
//   });

//   // Click outside
//   $(document).on('click', function (e) {
//     if (!$(e.target).closest('#qty-proxy').length) {
//       if ($btn.attr('aria-expanded') === 'true') closeDropdown();
//     }
//   });

//   // Button keydown
//   $(document).on('keydown', '#qty-proxy .cc-select__btn', function (e) {
//     if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
//       e.preventDefault();
//       openDropdown();
//     }
//     if (e.key === 'Escape') closeDropdown();
//   });

//   // Listbox keydown
//   $(document).on('keydown', '#qty-proxy .cc-select__listbox', function (e) {
//     var $current = getFocusedOption();
//     var index    = $options.index($current);

//     if (e.key === 'ArrowDown') {
//       e.preventDefault();
//       var $next = $options.eq(index + 1);
//       if ($next.length) highlightOption($next);
//     }

//     if (e.key === 'ArrowUp') {
//       e.preventDefault();
//       if (index <= 0) {
//         closeDropdown();
//       } else {
//         highlightOption($options.eq(index - 1));
//       }
//     }

//     if (e.key === 'Enter' || e.key === ' ') {
//       e.preventDefault();
//       selectOption($current);
//       closeDropdown();
//     }

//     if (e.key === 'Escape') {
//       e.preventDefault();
//       closeDropdown();
//     }

//     if (e.key === 'Tab') closeDropdown();
//   });

// // });



//   // ─── Events ──────────────────────────────────────────────────────────────

//   // Button click
//   $(document).on('click', '#qty-proxy .cc-select__btn', function (e) {
//     e.stopPropagation();
//     $btn.attr('aria-expanded') === 'true' ? closeDropdown() : openDropdown();
//   });

//   // Option click
//   $(document).on('click', '#qty-proxy .cc-select__option', function () {
//     selectOption($(this));
//     closeDropdown();
//   });

//   // Click outside
//   $(document).on('click', function (e) {
//     if (!$(e.target).closest('#qty-proxy').length) {
//       if ($btn.attr('aria-expanded') === 'true') closeDropdown();
//     }
//   });

//   // Button keydown
//   $(document).on('keydown', '#qty-proxy .cc-select__btn', function (e) {
//     if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
//       e.preventDefault();
//       openDropdown();
//     }
//     if (e.key === 'Escape') {
//       closeDropdown();
//     }
//   });

//   // Listbox keydown — NVDA reads aria-activedescendant from here
//   $(document).on('keydown', '#qty-proxy .cc-select__listbox', function (e) {
//     var $current = getFocusedOption();
//     var index    = $options.index($current);

//     if (e.key === 'ArrowDown') {
//       e.preventDefault();
//       var $next = $options.eq(index + 1);
//       if ($next.length) highlightOption($next);
//     }

//     if (e.key === 'ArrowUp') {
//       e.preventDefault();
//       if (index <= 0) {
//         closeDropdown();
//       } else {
//         highlightOption($options.eq(index - 1));
//       }
//     }

//     if (e.key === 'Enter' || e.key === ' ') {
//       e.preventDefault();
//       selectOption($current);
//       closeDropdown();
//       // NVDA will read the updated aria-label on the button after close
//     }

//     if (e.key === 'Escape') {
//       e.preventDefault();
//       closeDropdown();
//     }

//     if (e.key === 'Tab') {
//       closeDropdown();
//     }
//   });

// });


  





jQuery(document).ready(function ($) {

  $(document).on('keydown', '#quantity-select', function (e) {

    if (e.key === 'Enter') {
      // Prevent form submission
      e.preventDefault();
      e.stopPropagation();

      // Let native select handle open/close
      this.click();
    }

  });

});


// jQuery(document).ready(function ($) {

//   var $existingInput = $('#Quantity');
//   var currentValue = $existingInput.val() || '1';

//   var quantityHTML = `
//     <div class="qty-wrapper">
//       <div class="custom-select" id="customSelect">
//         <button type="button" class="custom-select__btn" id="selectBtn">
//           <span class="select-label">Quantity</span>
//           <span class="select-value" id="selectValue">${currentValue}</span>
//         </button>
//         <span class="custom-select__arrow">&#8964;</span>
//         <div class="custom-select__dropdown" id="selectDropdown">
//           <div class="custom-select__option selected" data-value="1">1</div>
//           <div class="custom-select__option" data-value="2">2</div>
//           <div class="custom-select__option" data-value="3">3</div>
//           <div class="custom-select__option" data-value="4">4</div>
//           <div class="custom-select__option" data-value="5">5</div>
//           <div class="custom-select__option" data-value="6">6</div>
//           <div class="custom-select__option" data-value="7">7</div>
//           <div class="custom-select__option" data-value="8">8</div>
//           <div class="custom-select__option" data-value="9">9</div>
//           <div class="custom-select__option" data-value="10+">10+</div>
//         </div>
//       </div>
//       <input type="hidden" name="quantity" id="quantityInput" value="${currentValue}">
//     </div>
//   `;

//   $('.qty-wrapper').replaceWith(quantityHTML);

//   // Mark the correct option as selected based on currentValue
//   $('#selectDropdown .custom-select__option').each(function () {
//     if ($(this).data('value').toString() === currentValue.toString()) {
//       $(this).addClass('selected');
//     } else {
//       $(this).removeClass('selected');
//     }
//   });

//   // Toggle dropdown open/close
//   $(document).on('click', '#selectBtn', function (e) {
//     e.stopPropagation();
//     $('#selectDropdown').toggleClass('open');
//   });

//   // Select an option
//   $(document).on('click', '.custom-select__option', function () {
//     var value = $(this).data('value');
//     $('.custom-select__option').removeClass('selected');
//     $(this).addClass('selected');
//     $('#selectValue').text(value);
//     $('#quantityInput').val(value);
//     // Also sync back to original Shopify input if present
//     $('#Quantity').val(value).trigger('change');
//     $('#selectDropdown').removeClass('open');
//   });

//   // Close dropdown when clicking outside
//   $(document).on('click', function (e) {
//     if (!$(e.target).closest('#customSelect').length) {
//       $('#selectDropdown').removeClass('open');
//     }
//   });

//   // Keyboard accessibility
//   $(document).on('keydown', '#selectBtn', function (e) {
//     if (e.key === 'Enter' || e.key === ' ') {
//       e.preventDefault();
//       $('#selectDropdown').toggleClass('open');
//     }
//     if (e.key === 'Escape') {
//       $('#selectDropdown').removeClass('open');
//     }
//   });

// });


// ============================================================================= Search  ================================================================================================


/**
 * search-a11y-fix.js
 * Accessibility fixes for the live search combobox.
 * Drop this file in /assets/ and include it AFTER theme.js.
 * No edits to theme.js required.
 */

(function ($) {
  'use strict';

  // ─── Configuration ───────────────────────────────────────────────────────────
  // Adjust these selectors if your theme uses different class names or IDs
  const CONFIG = {
    searchInput      : 'input[type="search"].search-form__input',
    resultContainer  : '.search-bar__results',
    listbox          : '.search-results__queries',
    optionItem       : '.search-result--query',
    liveRegionId     : 'search-a11y-live-region',
    observerTarget   : '.search-bar__results',   // element the MutationObserver watches
  };

  // ─── Step 1: Fix the broken label/input id (trailing space) ──────────────────
  function fixInputId() {
    $('label[for="open-search-closed "]').each(function () {
      $(this).attr('for', 'open-search-closed');
    });

    $('input#open-search-closed, input[id="open-search-closed "]').each(function () {
      $(this)
        .attr('id', 'open-search-closed')
        // FIX: Add combobox semantics to the input
        .attr({
          'role'              : 'combobox',
          'aria-expanded'     : 'false',
          'aria-controls'     : 'search-listbox',
          'aria-autocomplete' : 'list',
          'aria-activedescendant' : ''
        });
    });
  }

  // ─── Step 2: Inject the live region (once, before any search fires) ───────────
  function injectLiveRegion() {
    if ($('#' + CONFIG.liveRegionId).length) return; // already injected

    $('<div>', {
      id             : CONFIG.liveRegionId,
      role           : 'status',
      'aria-live'    : 'polite',
      'aria-atomic'  : 'true',
      css            : {
        position   : 'absolute',
        width      : '1px',
        height     : '1px',
        margin     : '-1px',
        padding    : '0',
        overflow   : 'hidden',
        clip       : 'rect(0,0,0,0)',
        whiteSpace : 'nowrap',
        border     : '0'
      }
    }).appendTo('body');
  }

  // ─── Step 3: Fix the rendered suggestions UL + LI items ──────────────────────
  function fixListbox($bar) {
    const $listbox = $bar.find(CONFIG.listbox);
    if (!$listbox.length) return;

    // Fix the <ul>: give it the id and label the input references
    $listbox
      .attr('id', 'search-listbox')
      .attr('aria-label', 'Search suggestions');

    // Fix each <li role="option">
    $bar.find(CONFIG.optionItem).each(function (i) {
      const $li  = $(this);
      const $a   = $li.find('a').first();
      const href = $a.attr('href') || '';

      $li
        // Unique id for aria-activedescendant to point at
        .attr('id', 'suggestion-' + i)
        .attr('aria-selected', 'false')
        // Store the URL so keyboard/click handler can navigate without an <a>
        .attr('data-href', href)
        .css('cursor', 'pointer');

      // FIX: Remove the <a> from inside role="option".
      //      <a> inside option creates duplicate tab stops and breaks the
      //      listbox contract. Replace it with its inner HTML only.
      $li.html($a.html());
    });
  }

  // ─── Step 4: Update ARIA state and announce results to screen readers ─────────
  function updateAriaState($bar) {
    const $input      = $bar.find(CONFIG.searchInput);
    const $options    = $bar.find('[role="option"]');
    const $liveRegion = $('#' + CONFIG.liveRegionId);
    const count       = $options.length;

    $input.attr('aria-expanded', count > 0 ? 'true' : 'false');

    // Announce suggestion count via live region
    $liveRegion.text(count > 0 ? count + ' suggestions available.' : '');
  }

  // ─── Step 5: Keyboard navigation ─────────────────────────────────────────────
  function initKeyboardNav($bar) {
    const $input = $bar.find(CONFIG.searchInput);

    // Remove any previously bound handler from this module to prevent stacking
    $input.off('keydown.a11ySearch');

    $input.on('keydown.a11ySearch', function (e) {
      const $options     = $bar.find('[role="option"]');
      const total        = $options.length;
      if (!total) return;

      // Find which option is currently "virtually focused"
      let activeIndex = $options.index($options.filter('[aria-selected="true"]'));

      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          activeIndex = activeIndex + 1 < total ? activeIndex + 1 : 0;
          setActiveOption($input, $options, activeIndex);
          break;

        case 'ArrowUp':
          e.preventDefault();
          activeIndex = activeIndex - 1 >= 0 ? activeIndex - 1 : total - 1;
          setActiveOption($input, $options, activeIndex);
          break;

        case 'Enter':
          // Only intercept Enter if a suggestion is virtually focused
          if (activeIndex >= 0) {
            e.preventDefault();
            const href = $options.eq(activeIndex).data('href');
            if (href) window.location.href = href;
          }
          // If nothing active, fall through to normal form submit
          break;

        case 'Escape':
          $input
            .attr('aria-expanded', 'false')
            .attr('aria-activedescendant', '');
          $('#' + CONFIG.liveRegionId).text('');
          $bar.find(CONFIG.resultContainer).empty();
          break;
      }
    });
  }

  // ─── Step 6: Click handler on listbox options ─────────────────────────────────
  function initClickNav($bar) {
    // Use event delegation so it works even after DOM is re-rendered
    $bar.off('click.a11ySearch', '[role="option"]');
    $bar.on('click.a11ySearch', '[role="option"]', function () {
      const href = $(this).data('href');
      if (href) window.location.href = href;
    });
  }

  // ─── Helper: move virtual focus to a specific option ─────────────────────────
  function setActiveOption($input, $options, index) {
    $options.attr('aria-selected', 'false');

    if (index < 0 || index >= $options.length) {
      $input.attr('aria-activedescendant', '');
      return;
    }

    const $active = $options.eq(index);
    $active.attr('aria-selected', 'true');
    $input.attr('aria-activedescendant', $active.attr('id'));
  }

  // ─── Step 7: Watch for DOM changes the theme makes to the results container ───
  // theme.js rebuilds .search-bar__results innerHTML on every keypress.
  // MutationObserver re-runs our fixes every time that happens.
  function observeSearchBars() {
    document.querySelectorAll(CONFIG.observerTarget).forEach(function (container) {
      const $bar = $(container).closest('[data-landmark-index]').length
        ? $(container).closest('[data-landmark-index]')
        : $(container).parent();

      const observer = new MutationObserver(function () {
        fixListbox($bar);
        updateAriaState($bar);
        // Keyboard nav is bound once via delegation; no need to re-bind
      });

      observer.observe(container, {
        childList : true,
        subtree   : true
      });
    });
  }

  // ─── Init ─────────────────────────────────────────────────────────────────────
  $(document).ready(function () {
    injectLiveRegion();
    fixInputId();

    // Fix any search bars already in the DOM (e.g. open on page load)
    $('[data-landmark-index]').each(function () {
      const $bar = $(this);
      fixListbox($bar);
      updateAriaState($bar);
      initKeyboardNav($bar);
      initClickNav($bar);
    });

    // Re-run fixInputId after modal open, in case search is in a lazy-rendered modal
    $(document).on('modalOpen.a11ySearch theme:search:open', function () {
      fixInputId();
      $('[data-landmark-index]').each(function () {
        const $bar = $(this);
        initKeyboardNav($bar);
        initClickNav($bar);
      });
    });

    // Watch the results containers for theme.js re-renders
    observeSearchBars();
  });

}(jQuery));



// ============================================================================= Aira-label bug id 49  ================================================================================================



/**
 * cbb-a11y-fix.js
 * Adds descriptive aria-label to CBB (Frequently Bought Together) product image links.
 * Include this file AFTER your theme scripts. No edits to theme files required.
 */

(function ($) {
  'use strict';

  // ─── Helper: Convert a URL slug to a readable product name ───────────────────
  // Input:  "/products/baseball-patchwork-bamboo-sleeper?variant=42842856259651"
  // Output: "baseball patchwork bamboo sleeper"
  function extractProductName(href) {
    if (!href) return '';

    // Grab only the pathname portion (strip query string / variant params)
    const path = href.split('?')[0];

    // Get the last segment after the final slash — that's the product handle
    const slug = path.split('/').filter(Boolean).pop();

    // Replace hyphens with spaces to form a human-readable name
    return slug ? slug.replace(/-/g, ' ') : '';
  }

  // ─── Core fix: find all CBB image links and add aria-label ───────────────────
  function fixCbbImageLinks() {
    $('a.cbb-frequently-bought-product-image-link[data-href]').each(function () {
      const $link      = $(this);
      const href       = $link.attr('data-href');
      const productName = extractProductName(href);

      if (productName) {
        $link.attr('aria-label', productName);
      }
    });
  }

  // ─── Watch for CBB widget being injected dynamically ─────────────────────────
  // CBB renders asynchronously after page load, so MutationObserver
  // catches it even if the links aren't in the DOM at document.ready
  function observeCbbWidget() {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          // Only process element nodes (ignore text nodes)
          if (node.nodeType !== 1) return;

          // Check if the added node itself is a CBB link
          if ($(node).is('a.cbb-frequently-bought-product-image-link')) {
            fixCbbImageLinks();
          }

          // Check if the added node contains CBB links as descendants
          if ($(node).find('a.cbb-frequently-bought-product-image-link').length) {
            fixCbbImageLinks();
          }
        });
      });
    });

    observer.observe(document.body, {
      childList : true,
      subtree   : true
    });
  }

  // ─── Init ─────────────────────────────────────────────────────────────────────
  $(document).ready(function () {
    // Fix any CBB links already in the DOM
    fixCbbImageLinks();

    // Watch for CBB links injected after page load
    observeCbbWidget();
  });

}(jQuery));



//============= Quantity dropdwon retesting issue //=============//=============//=============//=============//=============


(function ($) {
  'use strict';

  function initAccessibleDropdown() {
    var $wrapper = $('#qty-proxy');
    var $btn = $wrapper.find('.cc-select__btn');
    var $listbox = $wrapper.find('.cc-select__listbox');
    var $options = $listbox.find('.cc-select__option');
    var $qtyInput = $('#Quantity');
    var $label = $('#qty-proxy-label');
    var isOpen = false;

    // ── Fix static ARIA bugs on init ──────────────────────────────────────────
    var wrapperId = $wrapper.attr('id') || 'qty-proxy';

    // Button must reference BOTH label + its own live value so VoiceOver/NVDA
    // announce "Quantity, 1, collapsed" etc.
    $btn.attr({
      'aria-haspopup'     : 'listbox',
      'aria-expanded'     : 'false',
      'aria-labelledby'   : $label.attr('id') + ' ' + wrapperId + '-btn-val',
    });

    // Inject a hidden <span> inside the button that holds the current value.
    // Screen readers read aria-labelledby in order, so this produces
    // "Quantity  1" when collapsed and "Quantity  1" when open.
    var $btnVal = $('<span>', {
      id  : wrapperId + '-btn-val',
      'aria-hidden': 'false'          // must be visible to AT
    }).text($btn.text().trim().replace(/[^\w+]/g, '') || '1');
    // Remove raw text node, keep the SVG, prepend the labelled span
    $btn.contents().filter(function () {
      return this.nodeType === 3;     // text nodes only
    }).remove();
    $btn.prepend($btnVal);

    // Listbox: aria-hidden toggled on open/close; aria-activedescendant fixed
    $listbox.attr({
      'aria-label'           : 'Quantity',
      'aria-multiselectable' : 'false',
    });

    // Fix option IDs – original HTML had mixed formats (opt0 vs opt-0)
    $options.each(function (i) {
      $(this).attr('id', wrapperId + '-opt-' + i);
    });

    // ── Helpers ───────────────────────────────────────────────────────────────
    function getSelected() {
      return $options.filter('[aria-selected="true"]');
    }

    function getFocused() {
      return $options.filter('[data-focused="true"]');
    }

    function focusOption($opt) {
      $options.removeAttr('data-focused');
      $opt.attr('data-focused', 'true');
      $listbox.attr('aria-activedescendant', $opt.attr('id'));

      // Scroll option into view within the listbox
      var optTop    = $opt.prop('offsetTop');
      var optH      = $opt.outerHeight();
      var boxScroll = $listbox.scrollTop();
      var boxH      = $listbox.outerHeight();
      if (optTop < boxScroll) {
        $listbox.scrollTop(optTop);
      } else if (optTop + optH > boxScroll + boxH) {
        $listbox.scrollTop(optTop + optH - boxH);
      }
    }

    function selectOption($opt) {
      if (!$opt || !$opt.length) return;
      var val   = $opt.data('value').toString();
      var label = $opt.find('span').text().trim();

      // Update ARIA selected state
      $options.attr('aria-selected', 'false');
      $opt.attr('aria-selected', 'true');

      // Update visible button text + the labelled span AT reads
      $btnVal.text(label);

      // Sync the real <input> so form submission works
      var numericVal = parseInt(val, 10);
      $qtyInput.val(isNaN(numericVal) ? val : numericVal).trigger('change');

      // Announce selection to screen readers via aria-live
      announceToSR('Quantity ' + label + ' selected');
    }

    // Polite aria-live region – appended once, reused
    var $liveRegion = $('<div>', {
      'aria-live'   : 'polite',
      'aria-atomic' : 'true',
      'class'       : 'sr-only',
      'style'       : 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;'
    }).appendTo('body');

    function announceToSR(msg) {
      $liveRegion.text('');                       // clear first so repeat values re-trigger
      setTimeout(function () {
        $liveRegion.text(msg);
      }, 50);
    }

    function openListbox() {
      isOpen = true;
      $listbox.attr('aria-hidden', 'false').addClass('is-open');
      $btn.attr('aria-expanded', 'true');

      // Move visual focus to the currently selected option
      var $sel = getSelected();
      if (!$sel.length) $sel = $options.first();
      focusOption($sel);
      $listbox.focus();
    }

    function closeListbox(returnFocus) {
      isOpen = false;
      $listbox.attr('aria-hidden', 'true').removeClass('is-open');
      $btn.attr('aria-expanded', 'false');
      $options.removeAttr('data-focused');
      if (returnFocus !== false) $btn.focus();
    }

    // ── Button events ─────────────────────────────────────────────────────────
    $btn.on('click', function (e) {
      e.stopPropagation();
      isOpen ? closeListbox() : openListbox();
    });

    $btn.on('keydown', function (e) {
      switch (e.key) {
        case 'ArrowDown':
        case 'Down':
          e.preventDefault();
          openListbox();
          break;
        case 'ArrowUp':
        case 'Up':
          e.preventDefault();
          openListbox();
          break;
        case 'Enter':
        case ' ':
          e.preventDefault();
          isOpen ? closeListbox() : openListbox();
          break;
        case 'Escape':
          closeListbox();
          break;
      }
    });

    // ── Listbox keyboard navigation ───────────────────────────────────────────
    $listbox.on('keydown', function (e) {
      var $focused = getFocused();
      var $target;

      switch (e.key) {
        case 'ArrowDown':
        case 'Down':
          e.preventDefault();
          $target = $focused.length ? $focused.next('.cc-select__option') : $options.first();
          if ($target.length) {
            focusOption($target);
            // Announce new value during navigation (NVDA/VoiceOver)
            announceToSR($target.find('span').text().trim());
          }
          break;

        case 'ArrowUp':
        case 'Up':
          e.preventDefault();
          $target = $focused.length ? $focused.prev('.cc-select__option') : $options.last();
          if ($target.length) {
            focusOption($target);
            announceToSR($target.find('span').text().trim());
          }
          break;

        case 'Home':
          e.preventDefault();
          focusOption($options.first());
          announceToSR($options.first().find('span').text().trim());
          break;

        case 'End':
          e.preventDefault();
          focusOption($options.last());
          announceToSR($options.last().find('span').text().trim());
          break;

        case 'Enter':
        case ' ':
          e.preventDefault();
          if ($focused.length) {
            selectOption($focused);
            closeListbox();
          }
          break;

        case 'Escape':
        case 'Tab':
          closeListbox();
          break;

        default:
          // Type-ahead: jump to first option starting with pressed key
          var char = e.key.toLowerCase();
          if (char.length === 1) {
            var $match = $options.filter(function () {
              return $(this).find('span').text().trim().toLowerCase().indexOf(char) === 0;
            }).first();
            if ($match.length) {
              focusOption($match);
              announceToSR($match.find('span').text().trim());
            }
          }
          break;
      }
    });

    // ── Option mouse/touch selection ──────────────────────────────────────────
    $options.on('click', function (e) {
      e.stopPropagation();
      selectOption($(this));
      closeListbox();
    });

    $options.on('mouseenter', function () {
      focusOption($(this));
    });

    // ── Close on outside click ────────────────────────────────────────────────
    $(document).on('click.ccSelect', function (e) {
      if (!$(e.target).closest('#qty-proxy').length) {
        closeListbox(false);
      }
    });

    // ── Sync external input changes back to the custom select ─────────────────
    $qtyInput.on('change.ccSelect', function () {
      var newVal = $(this).val().toString();
      var $match = $options.filter(function () {
        return $(this).data('value').toString() === newVal;
      }).first();
      if ($match.length) {
        $options.attr('aria-selected', 'false');
        $match.attr('aria-selected', 'true');
        $btnVal.text($match.find('span').text().trim());
      }
    });
  }

  // ── Boot ──────────────────────────────────────────────────────────────────
  $(document).ready(function () {
    if ($('#qty-proxy').length) {
      initAccessibleDropdown();
    }
  });

}(jQuery));




